// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__s4Tsy","resendInfoText":"OnGoingPaymentBox_resendInfoText__153e9"};